module.exports = __webpack_public_path__ + "static/img/modern-thumb.acc48c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/modern-thumb.jpg
// module id = l6cQ
// module chunks = 0